import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  LockUserMutation,
  LockUserMutationVariables
} from "../../__generated__/types";
import { LOCK_USER_QUERY } from "./queries";

class LockUserM extends Mutation<LockUserMutation> {}

export interface Props {
  children(
    props: MutationFn<LockUserMutation, LockUserMutationVariables>
  ): JSX.Element | null;
}

export interface State {}

export default class LockUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <LockUserM
        mutation={LOCK_USER_QUERY}
        //refetchQueries={[{ query: ALL_USERS_QUERY }]}
        awaitRefetchQueries={true}
      >
        {mutation => this.props.children(mutation)}
      </LockUserM>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/LockUser/LockUser.tsx